import { FC, ReactNode } from 'react';
import clsx from 'clsx';
import './TaskPropertyRow.scss';

interface TaskPropertyRowProps {
  icon: ReactNode;
  children: ReactNode;
  action?: ReactNode;
  alignTop?: boolean;
  className?: string;
}

export const TaskPropertyRow: FC<TaskPropertyRowProps> = ({
  icon,

  children,
  action,
  alignTop = false,
  className,
}) => {
  return (
    <div
      className={clsx('task-property-row', alignTop && 'task-property-row--align-top', className)}
    >
      <div className="task-property-row__icon">{icon}</div>

      <div className="task-property-row__content">{children}</div>

      {action && <div className="task-property-row__action">{action}</div>}
    </div>
  );
};
